// extracted by mini-css-extract-plugin
module.exports = {"actionsDivider":"table_actionsDivider__1yFIo","actionDelete":"table_actionDelete__3CED3"};